import React, { forwardRef, useId } from 'react';

const Input = forwardRef(function Input({ label, error, className = '', ...props }, ref) {
  const generatedId = useId();
  const inputId = props.id || generatedId;

  return (
    <div className={className}>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">{label}</label>
      )}
      <input
        ref={ref}
        id={inputId}
        className={`block w-full rounded-lg border px-3 py-2 text-sm shadow-sm bg-white dark:bg-slate-800 text-gray-900 dark:text-slate-100 placeholder:text-gray-400 dark:placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
          error ? 'border-red-300' : 'border-gray-300 dark:border-slate-600'
        }`}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
});

export default Input;
